import { Injectable, Inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import {
  Sgkb709aRequest, Sgkb709aReqInclusiveCtrInfoDto, Sgkb709aReqSupplydemandcontractInfoDto,
  Sgkb709aResponse, SGKB709AService
} from 'sg-api';
import { map, timeout, catchError } from 'rxjs/operators';
import { ApiCommonService } from 'cbc-shared-lib';
import { TimeApiService } from 'cbc-shared-lib';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { SgkbConstains } from '../../../../sg-kb-shared/sg-kb-constans';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkb709aService {

  /** Response情報 */
  sgkb709aResponse: Sgkb709aResponse;

  /**
   * Constractor
   * Creates an instance of UsedSgkb709aService.
   * @memberof UsedSgkb709aService
   */
  constructor(
    private sGKB709AService: SGKB709AService,
    private apiCommonService: ApiCommonService,
    private timeApiService: TimeApiService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }


  /**
  * 包括契約登録 API呼び出し
  * @memberof UsedSgkb709aService
  */
  insertContract(ctrVal: any, dataSourceVal: any, selectedViewValue: string, warningFlg: boolean): Observable<Sgkb709aResponse> {
    // 包括契約登録操作コード
    const incRegCode: string = ctrVal.inclusioncontractRegOperationcode;
    let request: Sgkb709aRequest;
    // 包括契約登録操作コードが 登録、期中契約変更、契約更改 のいずれかの場合
    if (incRegCode === SgkbConstains.CODE.HOUKATSU_CNTRCT_RGST_OPE_CD.REGIST
      || incRegCode === SgkbConstains.CODE.HOUKATSU_CNTRCT_RGST_OPE_CD.CHANGE
      || incRegCode === SgkbConstains.CODE.HOUKATSU_CNTRCT_RGST_OPE_CD.RENEWAL) {
      request = {
        requestCommon: ctrVal.requestCommon,
        inclusiveCtrInfo: this.createInclusiveCtrInfo1(ctrVal, incRegCode, selectedViewValue, warningFlg),
        supplydemandcontractInfoList: this.createSupplydemandcontractInfoList1(dataSourceVal, ctrVal),
      };
    }

    // 包括契約登録操作コードが 解約、承認、取消 のいずれかの場合
    if (incRegCode === SgkbConstains.CODE.HOUKATSU_CNTRCT_RGST_OPE_CD.CANCEL_CNTRCT
      || incRegCode === SgkbConstains.CODE.HOUKATSU_CNTRCT_RGST_OPE_CD.APPROVAL
      || incRegCode === SgkbConstains.CODE.HOUKATSU_CNTRCT_RGST_OPE_CD.CANCEL) {
      request = {
        requestCommon: ctrVal.requestCommon,
        inclusiveCtrInfo: this.createInclusiveCtrInfo2(ctrVal, incRegCode, warningFlg),
        supplydemandcontractInfoList: this.createSupplydemandcontractInfoList2(dataSourceVal, incRegCode),
      };
    }

    return this.sGKB709AService.SGKB709APost(<Sgkb709aRequest>this.apiCommonService.setRequestCommon(request), 'response')
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkError(response);
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, SgkbConstains.MESSAGE.ID_FF, SgkbConstains.MESSAGE.APINAME_SGKB709A);
          return throwError(err.message);
        })
      );
  }

  /**
   * 包括契約情報 生成（登録、期中契約変更、契約更改）
   */
  private createInclusiveCtrInfo1(value: any, incRegCode: string, selectedViewValue: string, warningFlg: boolean): Sgkb709aReqInclusiveCtrInfoDto {

    let inclusiveCtrInfo: Sgkb709aReqInclusiveCtrInfoDto = {
      // 警告チェック対象外フラグ
      warncheckTargetgaiFlg: warningFlg,
      // 包括契約登録操作コード
      inclusioncontractRegOperationcode: value.inclusioncontractRegOperationcode,
      // 登録申請状況コード
      inclusioncontractRegistrationapplicationJokycd: value.inclusioncontractRegistrationapplicationJokycd,
      // 契約登録種別コード
      inclusioncontractRegistrationapplicationClscode: value.inclusioncontractRegistrationapplicationClscode,
      // 包括お客さま番号（包括契約登録操作コードが 期中契約変更、契約更改 の場合に設定）
      inclusioncontractVisitornumber: incRegCode === SgkbConstains.CODE.HOUKATSU_CNTRCT_RGST_OPE_CD.CHANGE
        || incRegCode === SgkbConstains.CODE.HOUKATSU_CNTRCT_RGST_OPE_CD.RENEWAL
        ? value.houkatsuOkyakusamaNo : null,
      // 包括契約履歴番号（同上）
      inclusioncontractRrkno: incRegCode === SgkbConstains.CODE.HOUKATSU_CNTRCT_RGST_OPE_CD.CHANGE
        || incRegCode === SgkbConstains.CODE.HOUKATSU_CNTRCT_RGST_OPE_CD.RENEWAL
        ? value.inclusioncontractRrkno : null,
      // 包括契約年度内通番号（同上）
      inclusioncontractYearnaiSrno: incRegCode === SgkbConstains.CODE.HOUKATSU_CNTRCT_RGST_OPE_CD.CHANGE
        || incRegCode === SgkbConstains.CODE.HOUKATSU_CNTRCT_RGST_OPE_CD.RENEWAL
        ? value.inclusioncontractYearnaiSrno : null,
      // 更新通番号（同上）
      updateSrno: incRegCode === SgkbConstains.CODE.HOUKATSU_CNTRCT_RGST_OPE_CD.CHANGE
        || incRegCode === SgkbConstains.CODE.HOUKATSU_CNTRCT_RGST_OPE_CD.RENEWAL
        ? value.updateSrno : null,
      // 包括お客さま名
      addrMno: value.houkatsuOkyakusamaName,
      // 住所コード（都道府県、行政市区、行政町名、丁目を連結して設定）
      addrCode: value.todoufukenCategory + value.gyouseishikuCategory +
        value.gyouseichomeiCategory + value.chomeCategory,
      // 番地・号・分筆号
      pcfdadrChomeKanjiAname: value.banchi,
      // 住宅・棟号漢字名
      supadrKanjiAname1: value.tatemonoName,
      // 屋号・業種漢字名
      yagyomoKanji: value.heyaNo,
      // 会社グループコード
      companygroupcode: value.comgrpcd,
      // 契約締結組織番号
      tantoSosikiId: value.keiyakuTantouBushoCategory,
      // 契約担当部署
      ctrTantobusho: selectedViewValue,
      // 契約締結社員番号（リスト）
      tantoStaffNo: value.keiyakuTantoushaCategory,
      // 契約締結社員名（テキスト）
      contractdateconclusionStaffname: value.keiyakuTantousha,
      // 包括お客さま担当部署
      inclusioncontractVisitTantobusho: value.houkatsuOkyakusamaTantoBusho,
      // 包括お客さま担当者
      inclusioncontractVisitTntsh: value.houkatsuOkyakusamaTantosha,
      // 包括お客さま電話番号
      inclusioncontractVisitTelno: value.houkatsuOkyakusamaTELNo,
      // 契約開始日
      inclusioncontractStartdate: this.timeApiService.convertDateToString(value.keiyakuKaishiYMD),
      // 包括契約適用年数
      inclusioncontractApplyNumberofyears: value.houkatsuTekiyouNensu,
      // 契約変更適用開始日（包括契約登録操作コードが 期中契約変更 の場合に設定）
      inclusioncontractCtrchgEffectivestartdate: incRegCode === SgkbConstains.CODE.HOUKATSU_CNTRCT_RGST_OPE_CD.CHANGE
        ? this.timeApiService.convertDateToString(value.keiyakuHenkouTekiyouKaishiYMD) : null,
      // 契約満了日
      inclusioncontractExpirationdate: this.timeApiService.convertDateToString(value.keiyakuManryouYMD),
      // 解約日
      inclusioncontractTerminationdate: null,
      // 包括割引・割増方法
      discountextraSyurui: value.houkatsuHouhouCategory,
      // メモ
      memo: value.memo,
    }
    return inclusiveCtrInfo;
  }

  /**
   * 包括契約情報 生成（解約、承認、取消）
   */
  private createInclusiveCtrInfo2(value: any, incRegCode: string, warningFlg: boolean): Sgkb709aReqInclusiveCtrInfoDto {

    let inclusiveCtrInfo: Sgkb709aReqInclusiveCtrInfoDto = {
      // 包括契約登録操作コード
      inclusioncontractRegOperationcode: value.inclusioncontractRegOperationcode,
      // 警告チェック対象外フラグ
      warncheckTargetgaiFlg: warningFlg,
      // 登録申請状況コード
      inclusioncontractRegistrationapplicationJokycd: incRegCode !== SgkbConstains.CODE.HOUKATSU_CNTRCT_RGST_OPE_CD.CANCEL_CNTRCT
        ? value.inclusioncontractRegistrationapplicationJokycd : null,
      // 契約登録種別コード
      inclusioncontractRegistrationapplicationClscode: incRegCode !== SgkbConstains.CODE.HOUKATSU_CNTRCT_RGST_OPE_CD.CANCEL_CNTRCT
        ? value.inclusioncontractRegistrationapplicationClscode : null,
      // 解約申請状況コード
      inclusioncontractBreakereqestJokycd: value.inclusioncontractBreakereqestJokycd === SgkbConstains.CODE.HOUKATSU_CANCEL_APLY_CD.APPLY
        ? value.inclusioncontractBreakereqestJokycd : null,
      // 包括お客さま番号
      inclusioncontractVisitornumber: value.houkatsuOkyakusamaNo,
      // 包括契約履歴番号
      inclusioncontractRrkno: value.inclusioncontractRrkno,
      // 包括契約年度内通番号
      inclusioncontractYearnaiSrno: value.inclusioncontractYearnaiSrno,
      // 契約開始日
      inclusioncontractStartdate: this.timeApiService.convertDateToString(value.keiyakuKaishiYMD),
      // 契約変更適用開始日（包括契約登録種別コードが 期中契約変更（需給契約の追加・解除） の場合に設定）
      inclusioncontractCtrchgEffectivestartdate: value.inclusioncontractRegistrationapplicationClscode === SgkbConstains.CODE.HOUKATSU_CNTRCT_REGIST_CLY_CD.MID_CHANGE
        ? this.timeApiService.convertDateToString(value.keiyakuHenkouTekiyouKaishiYMD) : null,

      // 更新通番号
      updateSrno: value.updateSrno,
      // 解約日
      inclusioncontractTerminationdate: this.timeApiService.convertDateToString(value.kaiyakuYMD),
      // メモ
      memo: value.memo,
    }
    return inclusiveCtrInfo;
  }

  /**
   * 包括対象需給契約情報　作成（登録、期中契約変更、契約更改）
   *
   * @private
   * @return {*}  {Sgkb709aReqSupplydemandcontractInfoDto}
   * @memberof UsedSgkb709aService
   */
  private createSupplydemandcontractInfoList1(listValue: any, val: any): Array<Sgkb709aReqSupplydemandcontractInfoDto> {
    let supplydemandcontractInfoList: Array<Sgkb709aReqSupplydemandcontractInfoDto> = [];

    if (!listValue?.length) {
      return supplydemandcontractInfoList;
    }

    listValue.forEach((value) => {
      let supplydemandcontractInfoDto: Sgkb709aReqSupplydemandcontractInfoDto = {
        // 包括契約内需給契約通番号
        inclusioncontractSupplydemandcontractSrno: value.inclusioncontractSupplydemandcontractSrno,
        // 初回検針予定日
        firstKenshinscheduledate: value.firstKenshinscheduledate,
        // 割引・割増開始日
        discountextraStartdate: value.discountextraStartdate,
        // 割引・割増解除日
        discountextraUnlockdate: value.discountextraUnlockdate,
        // 割引・割増金額
        discountextraMny: val.houkatsuHouhouCategory === SgkbConstains.CODE.DISCOUNT_PREMIUM_TYPE_CD.RATION_DISCOUNT
          || val.houkatsuHouhouCategory === SgkbConstains.CODE.DISCOUNT_PREMIUM_TYPE_CD.RATION_PREMIUM
          ? Number(value.discountextraPointMny) : null,
        // 割引・割増率
        // 割引・割増種類コード
        discountextraRate: val.houkatsuHouhouCategory === SgkbConstains.CODE.DISCOUNT_PREMIUM_TYPE_CD.FIXED_RATE_DISCOUNT
          || val.houkatsuHouhouCategory === SgkbConstains.CODE.DISCOUNT_PREMIUM_TYPE_CD.FIXED_RATE_PREMIUM
          ? value.discountextraRate : null,
        // 契約お客さま番号
        firstSrvctrNo: value.firstSrvctrNo,
        // 使用お客さま番号
        logicDeviceNo: value.logicDeviceNo,
        // 内部お客さま番号
        visitNo: value.visitNo,
        // 請求お客さま番号
        recptFixNo: value.recptFixNo,
      };
      supplydemandcontractInfoList.push(supplydemandcontractInfoDto);
    });
    return supplydemandcontractInfoList;
  }

  /**
   * 包括対象需給契約情報　作成（解約、承認、取消）
   *
   * @private
   * @return {*}  {Sgkb709aReqSupplydemandcontractInfoDto}
   * @memberof UsedSgkb709aService
   */
  private createSupplydemandcontractInfoList2(listValue: any, incRegCode: string): Array<Sgkb709aReqSupplydemandcontractInfoDto> {
    let supplydemandcontractInfoList: Array<Sgkb709aReqSupplydemandcontractInfoDto> = [];

    if (!listValue?.length) {
      return supplydemandcontractInfoList;
    }

    listValue.forEach((value) => {
      let supplydemandcontractInfoDto: Sgkb709aReqSupplydemandcontractInfoDto = {
        // 包括契約内需給契約通番号
        inclusioncontractSupplydemandcontractSrno: value.inclusioncontractSupplydemandcontractSrno,
        // 契約お客さま番号（包括契約登録操作コードが 承認 の場合に設定）
        firstSrvctrNo: incRegCode === SgkbConstains.CODE.HOUKATSU_CNTRCT_RGST_OPE_CD.APPROVAL
          ? value.firstSrvctrNo : null,
        // 使用お客さま番号（包括契約登録操作コードが 承認 の場合に設定）
        logicDeviceNo: incRegCode === SgkbConstains.CODE.HOUKATSU_CNTRCT_RGST_OPE_CD.APPROVAL
          ? value.logicDeviceNo : null,
        // 内部お客さま番号（包括契約登録操作コードが 承認 の場合に設定）
        visitNo: incRegCode === SgkbConstains.CODE.HOUKATSU_CNTRCT_RGST_OPE_CD.APPROVAL
          ? value.visitNo : null,
        // 請求お客さま番号（包括契約登録操作コードが 承認 の場合に設定）
        recptFixNo: incRegCode === SgkbConstains.CODE.HOUKATSU_CNTRCT_RGST_OPE_CD.APPROVAL
          ? value.recptFixNo : null,
      };
      supplydemandcontractInfoList.push(supplydemandcontractInfoDto);
    });
    return supplydemandcontractInfoList;
  }
}